<template>
  <div>
    <headerSection mainMenu="continue" />
    <main class="member-page continue-page">
      <div class="member-page__content">
        <MemberPageHeading
          eyebrow="Deposit streak"
          title="ฝากต่อเนื่อง"
          subtitle="ติดตามสถิติรายวันและปลดล็อกโบนัสในแต่ละขั้น"
        />

        <section class="member-card member-card--hero streak-card" aria-label="สถิติฝากต่อเนื่อง">
          <div class="streak-card__top">
            <div class="streak-ring" :style="{ '--streak-progress': `${streakProgress}%` }">
              <div class="streak-ring__inner">
                <strong>{{ streakCount }}</strong>
                <small>วันต่อเนื่อง</small>
              </div>
            </div>
            <div class="streak-copy">
              <small v-if="streakCount < nextMilestone">อีก {{ nextMilestone - streakCount }} วัน</small>
              <small v-else>ครบเป้าหมายแล้ว</small>
              <h2>รับโบนัสขั้น {{ nextMilestone }} วัน</h2>
              <p>ฝากสะสมวันละ 500 บาทขึ้นไป</p>
            </div>
          </div>

          <div class="streak-milestones">
            <div
              v-for="milestone in streakMilestones"
              :key="milestone"
              :class="['streak-milestone', milestoneClass(milestone)]"
            >
              <div class="streak-milestone__dot">{{ streakCount >= milestone ? '✓' : milestone }}</div>
              <small>{{ milestone }} วัน</small>
            </div>
          </div>
        </section>

        <section class="member-card streak-reward">
          <div>
            <span class="member-metric__label">โบนัสที่พร้อมรับ</span>
            <strong class="streak-reward__name">{{ activePromotionName }}</strong>
          </div>
          <div class="streak-reward__amount">
            <strong>{{ numberWithCommas(continues.total) }}</strong>
            <small>บาท</small>
          </div>
        </section>

        <div class="member-action-wrap">
          <MemberActionButton
            label="รับโบนัสเข้ากระเป๋าหลัก"
            :disabled="!continues.total || !continues.key"
            @click="moveContinuesToWallet"
          />
        </div>

        <div class="member-section-head">
          <h2 class="member-section-head__title">เงื่อนไขสำคัญ</h2>
          <span class="member-section-head__meta">โปรดอ่านก่อนรับ</span>
        </div>
        <details class="member-rule" open>
          <summary class="member-rule__summary">ยอดฝากและจำนวนวัน</summary>
          <div class="member-rule__content">
            <ul class="member-rule-list">
              <li>ครบ 3, 7, 15 หรือ 30 วัน รับเครดิตฟรีตามขั้นที่กำหนด</li>
              <li>ยอดฝากสะสมวันละ 500 บาทขึ้นไปจึงนับเป็น 1 วัน</li>
              <li>หากวันใดไม่ฝาก ระบบจะเริ่มนับหนึ่งใหม่ทันที</li>
            </ul>
          </div>
        </details>
        <details class="member-rule">
          <summary class="member-rule__summary">เทิร์นและยอดถอนสูงสุด</summary>
          <div class="member-rule__content">
            <ul class="member-rule-list">
              <li>ทำเทิร์น 2 เท่า และถอนได้สูงสุด 5 เท่า</li>
              <li>เมื่อถอน ระบบจะรีเซ็ตเครดิตที่เหลือตามเงื่อนไข</li>
              <li>หากมีเครดิตเกินยอดที่กำหนด ระบบจะดึงเครดิตส่วนเกินคืน</li>
            </ul>
          </div>
        </details>
        <details class="member-rule">
          <summary class="member-rule__summary">วันรับโบนัสและข้อควรระวัง</summary>
          <div class="member-rule__content">
            <ul class="member-rule-list">
              <li>เมื่อครบจำนวนวัน สามารถกดรับได้ในวันถัดไป</li>
              <li>หลังรับโบนัส ควรเล่นโบนัสให้เรียบร้อยก่อนฝากเพิ่มเพื่อไม่ให้ยอดติดเทิร์น</li>
            </ul>
          </div>
        </details>
      </div>
    </main>
    <footerSection />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
import axios from 'axios'
export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    MemberPageHeading: () => import('../components/member/MemberPageHeading.vue'),
    MemberActionButton: () => import('../components/member/MemberActionButton.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    streakCount () {
      return this.dots.filter(Boolean).length
    },
    streakMilestones () {
      return [3, 7, 15, 30]
    },
    nextMilestone () {
      return this.streakMilestones.find(milestone => milestone > this.streakCount) || 30
    },
    streakProgress () {
      return Math.min((this.streakCount / this.nextMilestone) * 100, 100)
    },
    activePromotionName () {
      return this.continues && this.continues.promotion
        ? this.continues.promotion.name
        : 'ฝากต่อเนื่อง 3 วัน'
    }
  },
  methods: {
    milestoneClass (milestone) {
      if (this.streakCount >= milestone) return 'streak-milestone--done'
      if (milestone === this.nextMilestone) return 'streak-milestone--next'
      return ''
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    async moveContinuesToWallet () {
      if (this.continues.total && this.continues.key) {
        this.$store.commit('user/SET_LOADING', true)
        try {
          const sitesCredit = await this.$store.dispatch('user/moveCreditToWallet')
          const currentCredit = this.getCurrentCredit(sitesCredit)
          if (currentCredit > 5) {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
            return
          }
          await axios.get(`https://api.xxmac.win/qcontinuous/continuous/${this.continues.key}`)
          setTimeout(() => {
            this.getContinues()
            this.$store.commit('user/SET_LOADING', false)
          }, 2000)
        } catch (err) {
          console.error(err)
          this.$store.commit('user/SET_LOADING', false)
        }
      }
    },
    getCurrentCredit (sitesCredit) {
      const credit = sitesCredit && typeof sitesCredit.credit !== 'undefined'
        ? sitesCredit.credit
        : this.user.credit
      return Number(credit || 0)
    },
    checkStyle () {
      if (this.continues && this.continues.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })
        // if (this.continues && this.continues.promotion) {
        //   for (let i = 0; i < Number(this.continues.promotion.numday); i++) {
        //     this.dots.push(true)
        //   }
        // } else {
          const fixed = 500
          let last = {}
          await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).where('promotionkey','==','ztg0QmfdVt4UzujIR2FG').orderBy('date', 'desc').limit(1).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              const data = doc.data()
              data.key = doc.id
              last = data
            })
          })
          const dateCheck = []
          if (last && last.date) {
            await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          } else {
            await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          }
          if (dateCheck) {
            for (let i = 1; i <= 30; i++) {
              if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
                this.dots.push(true)
              } else {
                break
              }
            }
          // }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>
<style scoped>
.streak-card__top {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
}

.streak-ring {
  width: 84px;
  height: 84px;
  padding: 7px;
  border-radius: 50%;
  background: conic-gradient(#ffca52 0 var(--streak-progress), rgba(255, 255, 255, .07) var(--streak-progress) 100%);
}

.streak-ring__inner {
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  border-radius: 50%;
  background: #0c1320;
  text-align: center;
}

.streak-ring__inner strong {
  display: block;
  color: #f7faff;
  font-size: 25px;
  line-height: .9;
}

.streak-ring__inner small,
.streak-copy small,
.streak-copy p {
  color: #8793aa;
  font-size: 9px;
}

.streak-copy h2 {
  margin: 4px 0;
  color: #f7faff;
  font-family: 'Kanit', sans-serif;
  font-size: 19px;
  font-weight: 500;
}

.streak-copy p { margin: 0; }

.streak-milestones {
  position: relative;
  z-index: 1;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.streak-milestones::before {
  position: absolute;
  top: 13px;
  right: 11%;
  left: 11%;
  height: 2px;
  background: #202b3d;
  content: '';
}

.streak-milestone {
  position: relative;
  z-index: 1;
  text-align: center;
}

.streak-milestone__dot {
  width: 27px;
  height: 27px;
  margin: 0 auto 6px;
  display: grid;
  place-items: center;
  border: 2px solid #26344a;
  border-radius: 50%;
  color: #65728a;
  background: #0c1320;
  font-size: 9px;
}

.streak-milestone small { color: #8793aa; font-size: 8px; }
.streak-milestone--done .streak-milestone__dot { border-color: #ffca52; color: #261800; background: #ffca52; }
.streak-milestone--done small { color: #e8c874; }
.streak-milestone--next .streak-milestone__dot { border-color: #528bff; color: #77a5ff; box-shadow: 0 0 0 4px rgba(47, 123, 255, .12); }

.streak-reward {
  margin-top: 12px;
  padding: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.streak-reward__name {
  display: block;
  margin-top: 3px;
  color: #f7faff;
  font-size: 16px;
  font-weight: 500;
}

.streak-reward__amount { color: #ffca52; text-align: right; }
.streak-reward__amount strong { display: block; font-size: 18px; font-weight: 600; }
.streak-reward__amount small { color: #8793aa; font-size: 9px; }
</style>
